import { Value } from "sass"

type Subdirectory = {
    path: string
    name: string
    detail?: string
    imagePath?: string
    isExternalLink: boolean
    subdirectories?: readonly Subdirectory[]
  }
  
  export type Route = {
    path: string
    name: string
    subdirectories: readonly Subdirectory[]
  }
  
  export const COMPANY_ROUTE = {
    path: '/en/company/',
    name: 'Corporate Information', 
    subdirectories: [
      {
        path: '/en/company/topmessage/',
        name: 'Top Message',
        imagePath: '/images/company-top-message-link.svg',
        isExternalLink: false,
      },
      {
        path: '/en/company/philosophy/',
        name: 'Philosophy',
        imagePath: '/images/company-philosophy-link.svg',
        isExternalLink: false,
      },
      {
        path: '/en/company/overview/',
        name: 'Company Profile',
        imagePath: '/images/company-overview-link.svg',
        isExternalLink: false,
      },
      {
        path: '/en/company/officer/',
        name: 'Board of Directors',
        imagePath: '/images/drawer-officer-links.svg',
        isExternalLink: false,
      },
      {
        path: '/en/company/history/',
        name: 'History',
        imagePath: '/images/company-history-link.svg',
        isExternalLink: false,
      },
      {
        path: '/en/company/access/',
        name: 'Access',
        imagePath: '/images/company-access-link.svg',
        isExternalLink: false,
      },
    ],
  } as const
  
  const BUSINESS_ROUTE = {
    path: '/en/business/',
    name: 'Our Business',
    subdirectories: [
      {
        path: '/en/business/#retail',
        name: 'Distribution Retail',
        imagePath: '/images/business-retail-links.svg',
        isExternalLink: false,
      },
      {
        path: '/en/business/#retail-ai',
        name: 'Retail AI',
        imagePath: '/images/business-retail-ai-links.svg',
        isExternalLink: false,
      },
      {
        path: '/en/business/#others',
        name: 'Other Business',
        imagePath: '/images/business-other-links.svg',
        isExternalLink: false,
      },
    ],
  } as const
  
  const NEWS_ROUTE = {
    path: '/en/news/',
    name: 'Newsroom',
    subdirectories: [
      {
        path: '/en/news/release/',
        name: 'News Release',
        imagePath: '/images/news-release.svg',
        isExternalLink: false,
      },

      // {
      //   path: '/en/news/blog/',
      //   name: '広報ブログ',
      //   imagePath: '/images/news-blog.svg',
      //   isExternalLink: false,
      // },
      // {
      //   path: '/en/news/media/',
      //   name: 'メディアキット',
      //   imagePath: '/images/news-media-kit.svg',
      //   isExternalLink: false,
      // },
      {
        path: '/en/news/video/',
        name: 'Video Library',
        imagePath: '/images/news-video-library.svg',
        isExternalLink: false,
      },
      // {
      //   path: '/en/news/exposure/',
      //   name: 'メディア露出一覧',
      //   imagePath: '/images/news-media-exposure.svg',
      //   isExternalLink: false,
      // },
    ],
  } as const
  
  export const IR_TOP_ROUTE = {
    path: '/en/ir/',
    name: 'Investor Relations',
    subdirectories: [
      {
        name: 'Top Messege',
        path: '/en/company/topmessage/',
        imagePath: '/images/company-top-message-link.svg',
        isExternalLink: false,
      },
      {
        name: '',
        path: '/en/ir/library/financial-announcement/',
        imagePath: '/images/serch_graph.svg',
        isExternalLink: false,
      },
      {
        name: 'To all individual investors',
        path: '/en/ir/investor',
        imagePath: '/images/bussiness-man-and-woman.svg',
        isExternalLink: false,
      },
      {
        name: 'IR News',
        path: '/en/ir/news/',
        imagePath: '',
        isExternalLink: false,
      },
      {
        name: 'Stock Price Chart',
        path: '/en/ir/stock/price/',
        imagePath: '',
        isExternalLink: false,
      },
      {
        name: 'Monthly Sales Report',
        path: '/en/ir/financial/monthly-sales/',
        imagePath: '',
        isExternalLink: false,
      },
      {
        name: 'Mid-Term Management Plan',
        path: '/en/ir/library/midtermplan/',
        imagePath: '',
        isExternalLink: false,
      },
      {
        name: 'IR calendar',
        path: '/en/ir/calendar/',
        imagePath: '',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_MANAGE_ROUTE = {
    path: '/en/ir/manage/',
    name: 'Management Policy',
    imagePath: '/images/globalnavi-ir-manage.svg',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'Top Message',
        path: '/en/company/topmessage/',
        imagePath: '/images/company-top-message-link.svg',
        detail:
          '"Enriching the world through Retail DX" A message from the Chairman and Representative Director.',
        isExternalLink: false,
      },
      {
        name: 'Philosophy',
        path: '/en/company/philosophy/',
        imagePath: '/images/company-philosophy-link.svg',
        detail:
          'Our group\'s purpose, vision, and values.',
        isExternalLink: false,
      },
      {
        name: 'Mid-Term Management \nPlan',
        path: '/en/ir/library/midtermplan/',
        imagePath: '/images/globalnavi-ir-manage.svg',
        detail:
          'Our group’s Medium-Term Management Plan(FY6/2027 – FY6/2029).',
        isExternalLink: false,
      },
      {
        name: 'Business Plan and \nGrowth Potential',
        path: '/en/ir/library/projection/',
        imagePath: '/images/projection-link.svg',
        detail:
          'Our business model, strategies and measures to achieve mid to long term growth.',
        isExternalLink: false,
      },
      {
        name: 'Issues',
        path: '/en/ir/manage/issue/',
        imagePath: '/images/issue-link.svg',
        detail: 'Business issues that should be addressed on a priority basis.',
        isExternalLink: false,
      },
      {
        name: 'Business Risks',
        path: '/en/ir/manage/risk/',
        imagePath: '/images/risk-link.svg',
        detail: 'The risks assumed for each business area.',
        isExternalLink: false,
      },
      {
        name: 'Disclosure / IR Policy',
        path: '/en/ir/manage/disclosure/',
        imagePath: '/images/disclosure-link.svg',
        detail: 'The basic policy regarding IR activities.',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_GOVERNANCE_ROUTE = {
    path: '/en/ir/governance/',
    name: 'Corporate Governance',
    isExternalLink: false,
    imagePath: '/images/globalnavi-ir-govanance.svg',
    subdirectories: [
      {
        name: 'Basic Policy',
        path: '/en/ir/governance/basics/',
        imagePath: '/images/ir-governance-basics.webp',
        detail:
          'The fundamental principles of corporate governance.',
        isExternalLink: false,
      },
      {
        name: 'Overview of Corporate Governance System',
        path: '/en/ir/governance/organization/',
        imagePath: '/images/ir-governance-organization.webp',
        detail:
          'An overview of the corporate governance structure and the reasons for adopting this system.',
        isExternalLink: false,
      },
  
      {
        name: 'Board of Directors',
        path: '/en/company/officer/',
        imagePath: '/images/officer-link.svg',
        detail: 'Information about our company\'s executive officers.',
        isExternalLink: false,
      },
      {
        name: 'Stakeholder Engagement',
        path: '/en/ir/governance/policy/',
        imagePath: '/images/ir-governance-policy.webp',
        detail:
          'Information on our initiatives and efforts regarding the respect for stakeholders\' positions.',
        isExternalLink: false,
      },
      {
        name: 'Internal Control\n Structure',
        path: '/en/ir/governance/internal-control/',
        imagePath: '/images/ir-governance-internal-control.webp',
        detail:
          'Information on the status of establishing internal control systems and risk management frameworks.',
        isExternalLink: false,
      },
      {
        name: 'Policy Against Antisocial Forces',
        path: '/en/ir/governance/antisocial/',
        imagePath: '/images/ir-governance-antisocial.webp',
        detail:
          'The fundamental approach to eliminate antisocial forces and the current status of our efforts this regard.',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_FINANCIAL_ROUTE = {
    path: '/en/ir/financial/',
    name: 'Financial Information',
    imagePath: '/images/globalnavi-ir-financial.svg',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'Monthly Sales Report',
        path: '/en/ir/financial/monthly-sales/',
        imagePath: '/images/ir-financial-monthly.webp',
        detail:
          'The monthly sales performance report for our group\'s sales outlets.',
        isExternalLink: false,
      },
      {
        name: 'Financial Highlights',
        path: '/en/ir/financial/review/',
        imagePath: '/images/ir-financial-review.webp',
        detail: 'The summary of the quarterly financial results.',
        isExternalLink: false,
      },
      {
        name: 'Chart Generator',
        path: '/en/ir/financial/chart/',
        imagePath: '/images/ir-financial-chart.png',
        detail: 'This page features tools that automatically generate charts and graphs from numerical and financial data.',
        isExternalLink: false,
      },
      {
        name: 'Consolidated Financial Statements',
        path: '/en/ir/financial/cfs/',
        imagePath: '/images/ir-financial-cfs.webp',
        detail: 'The consolidated Profit and Loss, Balance Sheet, and Cash Flow statements for our company\'s group.',
        isExternalLink: false,
      },
      {
        name: 'Consolidated Forecast',
        path: '/en/ir/financial/forecast/',
        imagePath: '/images/ir-financial-forecast.webp',
        detail: 'The consolidated performance forecast for our company\'s group.',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_LIBRARY_ROUTE = {
    path: '/en/ir/library/',
    name: 'IR Library',
    imagePath: '/images/globalnavi-ir-library.svg',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'Financial Statements\n Related Materials',
        path: '/en/ir/library/financial-announcement/',
        imagePath: '/images/irlibrary-financial-announcement-card.svg',
        detail: 'Documents related to financial statements, including the financial results briefing and financial results presentation materials.',
        isExternalLink: false,
      },
      {
        name: 'Securities Report',
        imagePath: '/images/irlibrary-securities-card.svg',
        detail: 'Quarterly reports and securities reports, including the annual securities report.',
        path: '/en/ir/library/securities/',
        isExternalLink: false,
      },
      {
        name: 'Mid-Term Management \nPlan',
        imagePath: '/images/globalnavi-ir-manage.svg',
        detail: 'Our group’s Medium-Term Management Plan(FY6/2027 – FY6/2029).',
        path: '/en/ir/library/midtermplan/',
        isExternalLink: false,
      },
      {
        name: 'Business Plan and \nGrowth Potential',
        path: '/en/ir/library/projection/',
        imagePath: '/images/irlibrary-projection-card.svg',
        detail:
          'This page contains information on our group\'s business model, strategies and measure to achieve medium- to long-term growth.',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_INVESTOR_ROUTE = {
    path: '/en/ir/investor/',
    name: 'To all individual Investors',
    imagePath: '/images/globalnavi-ir-Investor.svg',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'Top Message',
        path: '/en/company/topmessage/',
        imagePath: '/images/company-top-message-link.svg',
        isExternalLink: false,
        detail:
          'トップメッセージ「リテールDXを通じて世の中を豊かな社会へ」を掲載しております。',
      },
      {
        name: 'TRIAL Group\'s Bussiness Details',
        path: '/en/business/',
        imagePath: '/images/ir-business-link.svg',
        detail:
          '日本全国でディスカウントストアを運営している流通小売事業、流通業界に変革をもたらすAIソリューションを開発・提供するリテールAI事業について掲載しております。',
        isExternalLink: false,
      },
      {
        name: 'History',
        path: '/en/company/history/',
        imagePath: '/images/ir-history-link.svg',
        detail:
          '創業期から培ってきた「流通小売×リテールAI」における挑戦の歴史をご紹介しております。',
        isExternalLink: false,
      },
      {
        name: 'Business Plan and Growth Potencial',
        path: '/en/ir/library/projection/',
        imagePath: '/images/ir-library-projection-link.svg',
        detail:
          '当社グループのビジネスモデルや、中長期的な成長を実現するための戦略、施策などについて掲載しております。',
        isExternalLink: false,
      },
      {
        name: 'Financial Information',
        path: '/en/ir/financial/',
        imagePath: '/images/ir-financial-link.svg',
        detail:
          '月次売上高速報や、四半期ごとの決算概要、連結財務諸表、業績予想について掲載しております。',
        isExternalLink: false,
      },
      {
        name: 'Interested in becoming a shareholder?',
        path: '/en/ir/investor/shareholder/',
        imagePath: '/images/ir-investor-shareholder-link.svg',
        detail: '当社の経営に参加でき、また、配当金を受け取ることができます。',
        isExternalLink: false,
      },
      {
        name: 'IR Email Subscription',
        path: '/en/ir/mail/',
        imagePath: '/images/ir-mail-link.svg',
        detail:
          '当社の適時開示情報などIR情報について、ご登録のメールアドレスへ配信いたします。',
        isExternalLink: false,
      },
      {
        name: 'FAQ',
        path: '/en/ir/faq/',
        imagePath: '/images/ir-faq-link.svg',
        detail: 'よくいただくご質問とその回答について掲載しております。',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const IR_STOCK_ROUTE = {
    path: '/en/ir/stock/',
    name: 'Stock Information',
    imagePath: '/images/globalnavi-ir-stock.svg',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'Share Price Information',
        path: '/en/ir/stock/price/',
        imagePath: '/images/ir-stock-price.webp',
        detail: 'The share price chart.',
        isExternalLink: false,
      },
      {
        name: 'Basic Information',
        path: '/en/ir/stock/info/',
        imagePath: '/images/ir-stock-info.webp',
        detail: 'Basic information on our stock.',
        isExternalLink: false,
      },
      {
        name: 'Stock Situation',
        path: '/en/ir/stock/situation/',
        imagePath: '/images/ir-stock-situation.webp',
        detail: 'Number of shares issued and number of shareholders.',
        isExternalLink: false,
      },
      {
        name: 'Dividends and \nShareholder Returns',
        path: '/en/ir/stock/dividend/',
        imagePath: '/images/ir-stock-dividend.webp',
        detail:
          'Basic policy on profit distribution and information on dividends.',
        isExternalLink: false,
      },
      {
        name: 'Shareholder\'s Meeting',
        path: '/en/ir/stock/meeting/',
        imagePath: '/images/ir-stock-meeting.webp',
        detail: 'Notice of convocation of general meetings of shareholders, notice of resolutions, etc.',
        isExternalLink: false,
      },
      {
        name: 'Analyst Coverage',
        path: '/en/ir/stock/analyst-coverage/',
        imagePath: '/images/ir-library-projection-link.svg',
        detail: 'The list of analysts who cover TRIAL Holdings.',
        isExternalLink: false,
      },
      // {
      //   name: 'Articles of Incorporation\n and Rules for \nHandling Shares',
      //   path: '/en/ir/stock/articles/',
      //   imagePath: '/images/ir-stock-articles.webp',
      //   detail: 'XXX。',
      //   isExternalLink: false,
      // },
    ],
  } as const
  
  export const IR_OTHER_ROUTE = {
    name: 'Others',
    isExternalLink: false,
    subdirectories: [
      {
        name: 'IR News',
        path: '/en/ir/news/',
        imagePath: '/images/globalnavi-ir-news.svg',
        isExternalLink: false,
      },
      { name: 'IR Calendar', path: '/en/ir/calendar/', isExternalLink: false },
      { name: 'FAQ', path: '/en/ir/faq/', isExternalLink: false },
      { name: 'IR Inquiry', path: '/en/contact/ir/', isExternalLink: false },
      {
        name: 'IR Mail',
        path: '/en/ir/mail/',
        isExternalLink: false,
      },
      { name: 'Evaluation', path: '/en/ir/evaluation/', isExternalLink: false },
      // { name: 'Public Notice', path: '/en/public-notice/', isExternalLink: false },
      { name: 'Disclaimer', path: '/en/ir/disclaimer/', isExternalLink: false },
    ],
  } as const
  
  const IR_ROUTE = {
    path: '/en/ir/',
    name: 'Investor Relations',
    subdirectories: [
      IR_OTHER_ROUTE.subdirectories[0],
      IR_MANAGE_ROUTE,
      IR_GOVERNANCE_ROUTE,
      IR_FINANCIAL_ROUTE,
      IR_LIBRARY_ROUTE,
      IR_STOCK_ROUTE,
    ],
  } as const
  
  
  export const CAREERS_ROUTE = {
    path: '/en/careers/',
    name: 'Careers',
    subdirectories: [
      {
        path: 'https://www.trial-net.co.jp/recruit/newgraduate/',
        name: 'New Graduate',
        imagePath: '/images/careers-newgraduate-links.svg',
        detail: 'Contents in Japanese Only',
        isExternalLink: true,
      },
      {
        path: 'https://careers.trial-net.co.jp/',
        name: 'Mid-Career',
        imagePath: '/images/careers-trialgp-links.svg',
        detail: 'Contents in Japanese Only',
        isExternalLink: true,
      },
      {
        path: 'https://trial-recruit.net/jobfind-pc/',
        name: 'Part-time',
        imagePath: '/images/careers-jobfind-pc-links.svg',
        detail:
          'Contents in Japanese Only',
        isExternalLink: true,
      },
      {
        path: 'https://hrmos.co/pages/retail-ai',
        name: 'Retail AI',
        imagePath: '/images/careers-retail-ai-recruit-links.svg',
        detail:
          'Contents in Japanese Only',
        isExternalLink: true,
      },
    ],
  } as const
  
  export const LEGAL_ROUTE = {
    path: '/en/legal/',
    name: 'Legal',
    subdirectories: [
      {
        name: 'Privacy Policy',
        path: '/en/legal/privacy-policy/',
        isExternalLink: false,
      },
      {
        name: 'Terms of Use',
        path: '/en/legal/terms/',
        isExternalLink: false,
      },
      {
        name: 'Social Media Policy',
        path: '/en/legal/sns-policy/',
        isExternalLink: false,
      },
      {
        name: 'Information Security Policy',
        path: '/en/legal/security-policy/',
        isExternalLink: false,
      },
      {
        name: 'Code of Conduct',
        path: '/en/legal/code/',
        isExternalLink: false,
      },
      {
        name: 'Image Policy',
        path: '/en/legal/image-terms/',
        isExternalLink: false,
      },
    ],
  } as const
  
  export const CONTACT_ROUTE = {
    path: '/en/contact/',
    name: 'Inquiry',
    subdirectories: [
      {
        path: '/en/contact/media/',
        imagePath: '/images/contact-link.webp',
        name: 'Media',
        detail: 'For inquiries related to interviews, etc.',
        isExternalLink: false,
      },
      {
        path: '/en/contact/corporation/',
        imagePath: '/images/contact-link.webp',
        name: 'Corporate',
        detail: 'For inquiries about our business and services or proposals for collaboration.',
        isExternalLink: false,
      },
      {
        path: '/en/contact/ir/',
        imagePath: '/images/contact-link.webp',
        name: 'Investor Relations',
        detail: 'For inquiries about information for shareholders and investors.',
        isExternalLink: false,
      },
      // {
      //   path: 'http://ted.trial-net.co.jp/',
      //   imagePath: '/images/contact-link.webp',
      //   name: '出店希望の皆様',
      //   detail: '出店希望に関するお問い合わせ',
      //   isExternalLink: true,
      // },
      // {
      //   path: 'https://www.trial-net.co.jp/contacts/',
      //   imagePath: '/images/contact-link.webp',
      //   name: '個人のお客様',
      //   detail: 'トライアル店舗に関するお問い合わせ',
      //   isExternalLink: true,
      // },
      // {
      //   path: 'https://su-pay.jp/contact/',
      //   imagePath: '/images/contact-link.webp',
      //   name: 'SU-PAY',
      //   detail: 'フィナンシャルサービスに関するお問い合わせ',
      //   isExternalLink: true,
      // },
    ],
  } as const
  
  const SITE_MAP_ROUTE = {
    path: '/en/sitemap',
    name: 'Others',
    subdirectories: [
      {
        path: '/en/sitemap/',
        name: 'Site Map',
        isExternalLink: false,
      },
    ],
  } as const
  
  // 電子公告はサイトマップに表示させない
  // const PUBLIC_NOTICE_ROUTE = {
  //   path: '/en/public-notice',
  //   name: '電子公告',
  //   subdirectories: [
  //     {
  //       path: '/en/public-notice',
  //       name: '電子公告',
  //       isExternalLink: false,
  //     },
  //   ],
  // } as const
  
  export const NAVIGATIONS = [
    COMPANY_ROUTE,
    BUSINESS_ROUTE,
    NEWS_ROUTE,
    IR_ROUTE,
    CAREERS_ROUTE,
  ] as const
  
  export const FOOTER_BOTTOM_NAVIGATIONS = [
    { path: CONTACT_ROUTE.path, name: CONTACT_ROUTE.name },
    ...LEGAL_ROUTE.subdirectories,
    ...SITE_MAP_ROUTE.subdirectories,
  ] as const
  
  const CONTACT_SITE_MAP = {
    ...CONTACT_ROUTE,
    subdirectories: CONTACT_ROUTE.subdirectories.map((sub) => ({
      ...sub,
      name: sub.detail,
    })),
  }
  
  export const SITE_MAP_NAVIGATION = [
    COMPANY_ROUTE,
    BUSINESS_ROUTE,
    NEWS_ROUTE,
    IR_ROUTE,
    CONTACT_SITE_MAP,
    CAREERS_ROUTE,
    LEGAL_ROUTE,
    SITE_MAP_ROUTE,
  ] as const
  
